var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-items-center justify-content-center"},[_c('loader',{staticClass:"block-loader",attrs:{"position":"static","size":"30"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }